if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        
        if(window.location.href.includes("gift-with-purchase")){
          let sticky_atc = document.querySelector(".purchase-gifts__button a");
          sticky_atc.classList.add("loading");
          sticky_atc.classList.add("pointer-event-none");
          sticky_atc.closest('.purchase-gifts__button').classList.add("cursor-not-allowed");
          sticky_atc.querySelector('.loading__spinner').classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
      
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            let unlocked_gifts = document.querySelectorAll(".gifts-with__purchase .purchaseable.gift-unlocked");
            
            if(unlocked_gifts.length && window.location.href.includes("gift-with-purchase")){
              let cart_responce = await fetch(window.Shopify.routes.root + 'cart.js', {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              });

              let cart_object = await cart_responce.json();
              
              let items = [];
              let product_variant_id = document.querySelector(".gifts-with__purchase").getAttribute("data-productvariantid");
              for(var i=0;i<unlocked_gifts.length;++i){
                let variant_id = unlocked_gifts[i].getAttribute('data-variantid');
                let gift_already_present = cart_object.items.find((item) => item.variant_id == variant_id );

                if(!gift_already_present){
                  let gift_condition = unlocked_gifts[i].getAttribute("data-condition");
                  if(gift_condition == "quantity"){
                    let qty_value = unlocked_gifts[i].getAttribute("data-unlockquantity");
                    items.push({'id': variant_id,'quantity': 1, 'properties': { 'Gift': 'Free', 'Gift Condition': gift_condition, 'Unlock Quantity': qty_value, "_variant_id": product_variant_id }});
                  }else{
                    items.push({'id': variant_id,'quantity': 1, 'properties': { 'Gift': 'Free', 'Gift Condition': gift_condition, "_variant_id": product_variant_id }});
                  }
                  
                }
                
              }

              let giftData = {'items': items};

              await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(giftData)
              });
            }
             
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if(window.location.href.includes("gift-with-purchase")){
              let sticky_atc = document.querySelector(".purchase-gifts__button a");
              sticky_atc.classList.remove("loading");
              sticky_atc.classList.remove("pointer-event-none");
              sticky_atc.closest('.purchase-gifts__button').classList.remove("cursor-not-allowed");
              sticky_atc.querySelector('.loading__spinner').classList.add('hidden');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
